import * as y from "yup";

/**
 * Yup string schema that coerces GraphQL `null` to `""` during `cast()`.
 * Use on admin form fields loaded from Apollo where DB values may be null.
 */
export const nullableString = () =>
  y.string().nullable().transform((val) => val ?? "").trim();
